import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import CircleButton from './';
import GhostButton from '../basic/ghost';

function GhostCircleButton(props) {
  return /*#__PURE__*/React.createElement(CircleButton, _extends({
    Button: GhostButton
  }, props));
}

export default GhostCircleButton;